export const MapPreviewIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8607_19832)">
      <path
        d="M18.3337 8.33335V7.68126C18.3337 6.06491 18.3337 5.25675 17.8455 4.7546C17.3573 4.25247 16.5717 4.25247 15.0003 4.25247H13.2682C12.5037 4.25247 12.4973 4.25099 11.8099 3.90697L9.03358 2.51764C7.87436 1.93755 7.29476 1.64751 6.67731 1.66767C6.05985 1.68783 5.4993 2.01509 4.3782 2.66961L3.35498 3.267C2.53148 3.74776 2.11973 3.98815 1.89336 4.38805C1.66699 4.78796 1.66699 5.27496 1.66699 6.24896V13.0964C1.66699 14.3762 1.66699 15.0161 1.95221 15.3723C2.142 15.6092 2.40796 15.7685 2.70199 15.8214C3.14388 15.9007 3.68489 15.5849 4.76688 14.9531C5.50163 14.5242 6.20875 14.0787 7.08772 14.1995C7.82423 14.3007 8.50866 14.7654 9.16699 15.0949"
        stroke="#647DAF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 1.66669V14.1667"
        stroke="#647DAF"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 4.16669V7.91669"
        stroke="#647DAF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2566 18.0696C15.0759 18.2388 14.8344 18.3333 14.5831 18.3333C14.3318 18.3333 14.0903 18.2388 13.9096 18.0696C12.2549 16.5108 10.0376 14.7696 11.1189 12.2415C11.7036 10.8747 13.1071 10 14.5831 10C16.0591 10 17.4626 10.8747 18.0473 12.2415C19.1273 14.7663 16.9153 16.5162 15.2566 18.0696Z"
        stroke="#647DAF"
        strokeWidth="1.4"
      />
      <path
        d="M14.583 13.75H14.5905"
        stroke="#647DAF"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8607_19832">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
